<template>
  <div class="page_table_area permission">
    <!-- 标题 -->
    <div class="table_title_area">
      <div class="left">
        合计：<span class="blue">{{ pageData.total }}条</span>
      </div>
      <el-button class="btn_create right" @click="btnCreateClick" v-if="pms.create">
        <div class="btn_content">
          <div class="icon-create"></div>
          <div class="text_create">新建</div>
        </div>
      </el-button>
    </div>
    <!-- 表格 -->
    <div class="table_area">
      <el-table :data="tableData">
        <el-table-column :width="19 * docFontSize"></el-table-column>
        <el-table-column
          label="创建日期"
          prop="createTime"
          :width="34.4 * docFontSize"
        >
        <template slot-scope="scope">
          {{ scope.row.createTime | filterCreateDate}}
        </template>
        </el-table-column>
        <el-table-column
          label="岗位名称"
          prop="name"
          :width="32.5 * docFontSize"
        ></el-table-column>
        <el-table-column
          label="备注"
          prop="remarks"
          :width="47.4 * docFontSize"
        >
        <template slot-scope="scope">
          <div v-if="scope.row.remarks">{{scope.row.remarks}}</div>
        <div v-else style="color:#B5B5B5;">暂无备注</div>
        </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="btnEditClick(scope.row)"  v-if="pms.edit && scope.row.createTime">编辑</el-button>
          </template>
        </el-table-column>
       <template slot="empty">
         <table-empty></table-empty>
       </template>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination_area">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageData.page"
        :page-sizes="[20, 50, 100]"
        :page-size="pageData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageData.total"
      >
      </el-pagination>
    </div>
    <!-- 新建 -->
    <el-drawer
      :title="'岗位管理' + createTitleType"
      :visible.sync="showCreateDrawer"
      direction="rtl"
      custom-class="custom_drawer_y"
      :size="'66.7%'"
      :wrapperClosable="false"
      :before-close="handleDrawerClose"
    >
      <div class="drawer_content">
        <div class="name-kind_area">
          <div class="title">{{createTitleType}}</div>
          <div class="content">
            <div class="name">岗位名称：</div>
            <el-input
              class="input"
              v-model.trim="createData.name"
              placeholder="请输入岗位名称"
              maxlength="30"
              clearable
            ></el-input>
            <div class="kind">关联的单位类型：</div>
            <div class="units">
              <el-checkbox-group v-model="createData.types">
                <el-checkbox
                  :label="item.id"
                  v-for="(item, index) in arrUnitTypes"
                  :key="index"
                  @change="checkboxChange(item)"
                  :disabled="createData.typeState == 1"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="pms_area">
          <div class="title">该岗位可用权限</div>
          <div class="content">
            <div
              class="psm_level0"
              v-for="(item0, index0) in createData.menus"
              :key="index0"
            >
              <div class="pms_title">{{ item0.name }}</div>
              <div class="pms_page">
                <span class="left_title">浏览权限：</span>
                <el-radio v-model="item0.check" :label="true">可看</el-radio>
                <el-radio v-model="item0.check" :label="false" @change="checkItem0ChangedToFalse(item0)">不可看</el-radio>
              </div>
              <div v-show="item0.check">
                <div
                  class="pms_level0"
                  v-for="(item3, index3) in item0.arrLevel0"
                  :key="index3 + 3000"
                >
                  <span class="left_title">{{ item3.name }}：</span>
                  <el-radio-group v-model="item3.selected">
                    <el-radio
                      :label="item31.id"
                      v-for="(item31, index31) in item3.children"
                      :key="index31"
                      >{{ item31.name }}</el-radio
                    >
                  </el-radio-group>
                </div>
                <div class="pms_sub">
                  <span class="left_title">操作：</span>
                  <span class="checkbox_all">
                    <el-checkbox
                      v-model="item0.childrenSelectedAll"
                      @change="pmsItem0SelectAll(item0)"
                    >
                      全部
                    </el-checkbox>
                  </span>
                  <el-checkbox-group v-model="item0.childrenSelected" v-for="(item1, index1) in item0.children"
                      :key="index1">
                    <el-checkbox
                      
                      :label="item1.id"
                      @change="pmsItem0ChildSelect(item0)"
                      >{{ item1.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
                <!-- 下级详情 -->
                <div
                  class="pms_sub_details"
                  v-for="(item2, index2) in item0.arrSubPms"
                  :key="index2"
                >
                  <div class="pms_title">
                    {{ item0.name + "-" + item2.name }}
                  </div>
                  <div class="pms_page">
                    <span class="left_title">浏览权限：</span>
                    <el-radio v-model="item2.check" :label="true"
                      >可看</el-radio
                    >
                    <el-radio v-model="item2.check" :label="false" @change="checkItem2ChangedToFalse(item2)"
                      >不可看</el-radio
                    >
                  </div>
                  <div v-show="item2.check">
                    <div class="pms_sub">
                      <span class="left_title">操作：</span>
                      <span class="checkbox_all">
                        <el-checkbox
                          v-model="item2.childrenSelectedAll"
                          @change="pmsItem0SelectAll(item2)"
                        >
                          全部
                        </el-checkbox>
                      </span>
                      <el-checkbox-group v-model="item2.childrenSelected" v-for="(item21, index21) in item2.children"
                          :key="index21">
                        <el-checkbox
                          
                          :label="item21.id"
                          @change="pmsItem0ChildSelect(item2)"
                          >{{ item21.name }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="remarks">
            <div class="remarks_title">备注</div>
            <el-input
              type="text"
              v-model="createData.remarks"
              maxlength="30"
            >
            <span class="remarkLength" slot="suffix"><span style="color:#2C90FF;">{{createData.remarks | remarkLength}}</span>/30</span>
            </el-input>
          </div>
        </div>
      </div>
      <div class="drawer_footer">
        <el-button @click="showCreateDrawer = false">取消</el-button>
        <el-button type="primary" @click="btnDoneCreateClick">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import TableEmpty from '../../../../components/TableEmpty.vue';
import mixins from "./Mixins";
export default {
  components: { TableEmpty },
  mixins: [mixins],
  data() {
    return {
      pms:{
        create:false,
        edit:false
      }
    };
  },
  computed: {
    tableData() {
      return this.Permission.tableData;
    },
    pageData() {
      return this.Permission.pageData;
    },
    showCreateDrawer: {
      get() {
        return this.Permission.showCreateDrawer;
      },
      set(v) {
        this.SETOPTIONS({
          showCreateDrawer: v,
        });
      },
    },
    arrUnitTypes() {
      return this.Permission.arrUnitTypes;
    },
    createData() {
      return this.Permission.createData;
    },
    createTitleType() {
      if(this.createData.id) {
        return '编辑'
      } else {
        return '新建'
      }
    }
  },
  filters:{
    filterCreateDate(v){
      if(v && v.indexOf(" ") >= 0) {
        return v.split(" ")[0];
      } else {
        return ""
      }
    },
    remarkLength(v) {
      if(v) {
        return v.length;
      } else {
        return 0
      }
    }
  },
  created(){
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"))
    this.pms.create = pms["30100"].check;
    this.pms.edit = pms["30200"].check;
    
  },
  mounted() {
    this.getUnitType_A();
  },

  methods: {
    btnCreateClick() {
      this.SETOPTIONS({
        createData: {
          name: "",
          types: [],
          menus: [],
          remarks: "",
          typeState:0
        },
      });
      
      this.getPmsList_A();
      this.showCreateDrawer = true;
    },
    checkItem0ChangedToFalse(item0) {
      const that = this;
      item0.childrenSelected = []
      item0.childrenSelectedAll = false;
      item0.arrLevel0.forEach(item => {
        item.selected = ""
      })
      item0.arrSubPms.forEach(item2 =>{
        if(item2.check) {
          item2.check = false;
          that.checkItem2ChangedToFalse(item2)
        }
      })
    },
    checkItem2ChangedToFalse(item2) {
      item2.childrenSelected = []
      item2.childrenSelectedAll = false;
    },
    async btnEditClick(row) {
      this.SETOPTIONS({
        createData: {
          id:row.id,
          name: row.name,
          types: row.type.split(","),
          menus: [],
          remarks: row.remarks,
          typeState:1
        },
      });
      this.getPmsList_A(row.id);
      this.showCreateDrawer = true;
    },
    handleSizeChange() {
      this.getTableList_A();
    },
    handleCurrentChange() {
      this.getTableList_A();
    },
    handleDrawerClose() {
      this.showCreateDrawer = false;
      this.SETOPTIONS({
        createData: {
          name: "",
          types: [],
          menus: [],
          remarks: "",
        },
      });
    },
    checkboxChange(item) {
      if (this.createData.types.indexOf(item.id) >= 0) {
        for (let i = this.createData.types.length - 1; i >= 0; i--) {
          let idThis = this.createData.types[i];
          let itemThis = this.getItemWithId(idThis);
          if (itemThis.type != item.type) {
            this.createData.types.splice(i, 1);
          }
        }
      }
    },
    getItemWithId(id) {
      let result;
      for (let i = 0; i < this.arrUnitTypes.length; i++) {
        let item = this.arrUnitTypes[i];
        if (item.id == id) {
          result = item;
          break;
        }
      }
      return result;
    },
    // 权限列表
    //一级操作全部按钮
    pmsItem0SelectAll(item0) {
      if (item0.childrenSelectedAll) {
        item0.children.forEach((item) => {
          if (item0.childrenSelected.indexOf(item.id) < 0) {
            item0.childrenSelected.push(item.id);
          }
        });
      } else {
        item0.childrenSelected.splice(0, item0.childrenSelected.length);
      }
    },
    // 一级操作单独功能
    pmsItem0ChildSelect(item0) {
      if (
        item0.childrenSelected.length == item0.children.length &&
        item0.children.length > 0
      ) {
        item0.childrenSelectedAll = true;
      } else if (
        item0.childrenSelected.length != item0.children.length &&
        item0.children.length > 0
      ) {
        item0.childrenSelectedAll = false;
      }
    },
    // 保存权限
    async btnDoneCreateClick() {
      if (this.createData.name.length == 0) {
        this.$Message({
          type: "error",
          message: "请填写岗位名称",
        });
        return;
      }
      if (this.createData.name.length < 2 || this.createData.name.length > 30) {
        this.$Message({
          type: "error",
          message: "请输入2~30位岗位名称",
        });
        return;
      }
      if (this.createData.types.length == 0) {
        this.$Message({
          type: "error",
          message: "请选择单位类型",
        });
        return;
      }
      if(this.createData.remarks) {
        this.createData.remarks = this.createData.remarks.trim();
      } else {
        this.createData.remarks = "";
      }
      let success = await this.createEditPms_A();
      if (success) {
        this.showCreateDrawer = false;
        this.SETOPTIONS({
          createData: {
            name: "",
            types: [],
            menus: [],
            remarks: "",
          },
          pageData: {
            page: 1,
            size: this.pageData.size,
            total: 0,
          },
        });
        this.getTableList_A();
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.page_table_area.permission {
  .drawer_content {
    // width:1210px;
    margin-bottom: 100px;
    overflow: auto;
    position: absolute;
    top: 108px;
    left: 0;
    bottom: 0;
    right: 0;

    .name-kind_area {
      border: #CCD7EA solid 1px;

      .title {
        padding-left: 30px;
        height: 60px;
        font-size: 16px;
        background-color: #F1F4F9;
        line-height: 60px;
        font-weight: 500;
        border-bottom: #CCD7EA solid 1px;
      }

      .input {
        width: 220px;
      }

      .content {
        height: 80px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .name, .kind {
          margin-left: 30px;
        }
        .name {
          margin-right:24px;
        }

        .units {
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: #000;
        }
      }
      .el-checkbox {
        margin:0 10px;  
      }
    }

    .pms_area {
      border: #CCD7EA solid 1px;
      margin-top: 20px;

      .title {
        padding-left: 30px;
        height: 60px;
        font-size: 16px;
        background-color: #F1F4F9;
        line-height: 60px;
        font-weight: 500;
        border-bottom: #CCD7EA solid 1px;
      }

      .content {
        min-height: 80px;
        margin-left: 3rem;

        .pms_title {
          margin: 20px 10px 10px 0;
          font-size: 16px;
          color: #000;
          font-weight: 500;
          height: 22px;
          line-height: 22px;
        }

        .pms_page, .pms_sub, .pms_level0 {
          margin: 10px 10px 10px 0;
          color: #040300;
          font-size: 14px;
          // height: 20px;
          line-height: 20px;

          .left_title {
            margin-right:20px;
          }
        }

        // .pms_sub {
        // margin: 10px 10px 10px 0;
        // }
        .checkbox_all {
          margin-right: 30px;
        }
      }

      .remarks {
        margin: 20px 86px 70px 30px;

        .remarks_title {
          margin: 20px 10px 10px 0;
          font-size: 16px;
          color: #000;
          font-weight: 500;
          height: 22px;
          line-height: 22px;
        }
        .remarkLength {
          line-height:40px;
        }
      }

      .el-checkbox-group {
        display: inline-block;
        margin-right: 30px;
      }
    }
  }
  // 单选多选
    .el-radio ,.el-checkbox{
        color: #000000;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/PartI/PermissionPackage/components/pmsTable.vue